import { render, staticRenderFns } from "./ZeigeKundenbetreuer.vue?vue&type=template&id=3ecfd9e1&"
import script from "./ZeigeKundenbetreuer.vue?vue&type=script&lang=js&"
export * from "./ZeigeKundenbetreuer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports